// Features.js
import { motion } from "framer-motion";
import { FaCloud, FaFileInvoice, FaChartBar, FaUserShield, FaHeadset, FaMobileAlt } from "react-icons/fa";

const featuresList = [
  {
    icon: <FaCloud size={36} className="text-sky-500" />,
    title: "نظام سحابي",
    description: "الوصول إلى بياناتك من أي مكان وفي أي وقت دون الحاجة إلى خوادم محلية ",
    image: "/images/cloud.jpg"
  },
  {
    icon: <FaFileInvoice size={36} className="text-yellow-500" />,
    title: "فواتير إلكترونية",
    description: "إنشاء وإرسال وتتبع الفواتير بطريقة احترافية ومتوافقة مع ضريبة الزكاة والدخل ",
    image: "/images/invoice.webp"
  },
  {
    icon: <FaChartBar size={36} className="text-green-500" />,
    title: "تحليلات وتقارير",
    description: "تقديم تقارير مفصلة تساعد في اتخاذ قرارات استراتيجية دقيقة",
    image: "/images/report.jpg"
  },
  {
    icon: <FaUserShield size={36} className="text-red-500" />,
    title: "أمان عالي",
    description: "نظام محمي بالكامل بتقنيات تشفير حديثة لحماية بياناتك ",
    image: "/images/data.jpg"
  },
  {
    icon: <FaHeadset size={36} className="text-purple-500" />,
    title: "دعم فني مستمر",
    description: "فريق دعم متوفر 24/7 لضمان استمرارية عمل النظام بدون توقف ",
    image: "/images/call.jpg"
  },
  {
    icon: <FaMobileAlt size={36} className="text-pink-500" />,
    title: "تطبيقات جوال",
    description: "إدارة عملياتك من الجوال بكل سهولة ومرونة ",
    image: "/images/mobile.jpg"
  },
];

export default function Features() {
  return (
    <section className="py-20 px-6 bg-gradient-to-b from-white via-blue-50 to-white text-center" id="features">
      <h2 className="text-3xl md:text-4xl font-bold mb-16 text-blue-900 relative">
        <span className="inline-block relative z-10">مميزات موبي كاشير</span>
        <span className="absolute bottom-0 left-1/2 w-24 h-1 bg-yellow-400 transform -translate-x-1/2"></span>
      </h2>
      <div className="grid gap-16">
        {featuresList.map((feature, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2, delay: idx * 0.2 }}
            viewport={{ once: true }}
            className={`flex flex-col md:flex-row items-center bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 ${idx % 2 !== 0 ? 'md:flex-row-reverse' : ''}`}
          >
            <img
              src={feature.image}
              alt={feature.title}
              className="w-full md:w-1/2 h-72 object-cover md:rounded-none"
            />
            <div className="p-8 text-right md:w-1/2">
              <div className="mb-4 flex justify-end">
                {feature.icon}
              </div>
              <h3 className="text-2xl font-bold text-blue-800 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-base leading-relaxed">
                {feature.description}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
